
import each from "lodash/each";
import extend from "lodash/extend";
import map from "lodash/map";

/**
 * Percent-encode every special character in an email-address, except for the @-sign
 * @param {String} address e-mail address to endcode
 */
export function encodeEmailAddress(address) {
  return address
    .split("@")
    .map(part => encodeURIComponent(part))
    .join("@");
}

export const clearString = str => {
  return str
    .toString()
    .replace(/&amp;/g, "＆")
    .replace(/&/g, "＆")
    .replace(/ß/g, "ẞ")
    .replace(/</g, "ᐸ")
    .replace(/>/g, "ᐳ")
    .replace(/"/g, "ʺ")
    .replace(/Á/g, "\u0041\u0301")
    .replace(/À/g, "\u0041\u0300")
    .replace(/Ä/g, "\u0041\u0308")
    .replace(/Ã/g, "\u0041\u0303")
    .replace(/Â/g, "\u0041\u0302")
    .replace(/Å/g, "\u0041\u030A")
    .replace(/Ç/g, "\u0043\u0327")
    .replace(/É/g, "\u0045\u0301")
    .replace(/È/g, "\u0045\u0300")
    .replace(/Ë/g, "\u0045\u0308")
    .replace(/Ê/g, "\u0045\u0302")
    .replace(/Í/g, "\u0049\u0301")
    .replace(/Ì/g, "\u0049\u0300")
    .replace(/Ï/g, "\u0049\u0308")
    .replace(/Î/g, "\u0049\u0302")
    .replace(/Ñ/g, "\u004e\u0303")
    .replace(/Ó/g, "\u004F\u0301")
    .replace(/Ò/g, "\u004F\u0300")
    .replace(/Ö/g, "\u004F\u0308")
    .replace(/Ô/g, "\u004F\u0302")
    .replace(/Ú/g, "\u0055\u0308")
    .replace(/Ù/g, "\u0055\u0300")
    .replace(/Ü/g, "\u0055\u0308")
    .replace(/Û/g, "\u0055\u0302")
    .replace(/á/g, "\u0061\u0301")
    .replace(/à/g, "\u0061\u0300")
    .replace(/ã/g, "\u0061\u0303")
    .replace(/ä/g, "\u0061\u0308")
    .replace(/â/g, "\u0061\u0302")
    .replace(/å/g, "\u0061\u030a")
    .replace(/ç/g, "\u0063\u0327")
    .replace(/é/g, "\u0065\u0301")
    .replace(/è/g, "\u0065\u0300")
    .replace(/ë/g, "\u0065\u0308")
    .replace(/ê/g, "\u0065\u0302")
    .replace(/ó/g, "\u006f\u0301")
    .replace(/ò/g, "\u006e\u0300")
    .replace(/ô/g, "\u006f\u0302")
    .replace(/ö/g, "\u006f\u0308")
    .replace(/ù/g, "\u0075\u0301")
    .replace(/ú/g, "\u0075\u0300")
    .replace(/ü/g, "\u0075\u0308")
    .replace(/û/g, "\u0075\u0302")
    .replace(/í/g, "\u0069\u0301")
    .replace(/ì/g, "\u0069\u0300")
    .replace(/ì/g, "\u0069\u0300")
    .replace(/ï/g, "\u0069\u0308")
    .replace(/î/g, "\u0069\u0302")
    .replace(/ñ/g, "\u006e\u0303");
};

export function minimizeString(str, maxLengt) {
  return str.length > maxLengt ? `${str.substr(0, maxLengt)}...` : str;
}

export function parseQueryString(queryString) {
  let params = {};
  if (queryString) {
    if (queryString.indexOf("?") > -1) {
      queryString = queryString.substring(queryString.indexOf("?") + 1);
    }
    if (queryString.indexOf("#") > -1) {
      queryString = queryString.substring(0, queryString.indexOf("#"));
    }

    each(
      map(decodeURI(queryString).split(/&/g), function(el) {
        const aux = el.split("="),
          o = {};
        if (aux.length >= 1) {
          let val = undefined;

          if (aux.length === 2) {
            val = aux[1];
          }
          o[aux[0]] = val;
        }
        return o;
      }),
      function(o) {
        extend(params, o);
      }
    );
  }
  return params;
}

/**
 * Checks if first string contains second string ignoring (camel) case
 * @param str
 * @param subStr
 * @returns {boolean}
 */
export function contains(str, subStr) {
  return str && str.toLowerCase().indexOf(subStr.toLowerCase()) > -1;
}

/**
 * This function compares to string versions
 * @param v1
 * @param v2
 * @returns {*}
 */
export function compareVersionNumbers(v1, v2) {
  let v1parts = v1.split(".");
  let v2parts = v2.split(".");

  // First, validate both numbers are true version numbers
  function validateParts(parts) {
    for (let i = 0; i < parts.length; ++i) {
      if (!/^\d+$/.test(parts[i])) {
        return false;
      }
    }
    return true;
  }

  if (!validateParts(v1parts) || !validateParts(v2parts)) {
    return NaN;
  }

  for (let i = 0; i < v1parts.length; ++i) {
    if (v2parts.length === i) {
      return 1;
    }

    if (v1parts[i] === v2parts[i]) {
      continue;
    }
    if (v1parts[i] > v2parts[i]) {
      return 1;
    }
    return -1;
  }

  if (v1parts.length !== v2parts.length) {
    return -1;
  }

  return 0;
}

export const serializeObjToFormDataString = object => {
  let result = "";
  for (let key in object) {
    if (object[key] instanceof Array) {
      for (let i = 0; i < object[key].length; i++) {
        result += `${key}=${object[key][i]}&`;
      }
    } else {
      result += `${key}=${object[key]}&`;
    }
  }
  return result.substr(0, result.length - 1);
};

export const sameObjects = (obj1, obj2) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};



// WEBPACK FOOTER //
// ./src-cookie-manager/utils/string-utils.js